import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-agent-reclaim-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./agent-reclaim-modal.component.html",
  styleUrl: "./agent-reclaim-modal.component.scss",
})
export class AgentReclaimModalComponent {
  @Input() configs: any = {};

  // NgbModal assigns componentInstance properties AFTER ngOnInit fires,
  // so a setter is required to initialise allItems at the right time.
  @Input() set agents(value: any[]) {
    this._agents = value ?? [];
    this.initItems();
  }
  get agents(): any[] { return this._agents; }

  private _agents: any[] = [];

  activeModal = inject(NgbActiveModal);

  allItems: any[] = [];
  selectedItems: any[] = [];

  private readonly typeIconMap: Record<string, string> = {
    Local:   'assets/images/virtusa-icons/local-agent.svg',
    Cluster: 'assets/images/virtusa-icons/cluster-agent.svg',
    LOCAL:   'assets/images/virtusa-icons/local-agent.svg',
    CLUSTER: 'assets/images/virtusa-icons/cluster-agent.svg',
  };

  private initItems(): void {
    this.allItems = this._agents.map((agent: any) => ({
      ...agent,
      typeLabel: this.toTitleCase(agent.typeLabel ?? agent.type),
      statusLabel: this.toTitleCase(agent.statusLabel ?? agent.status),
      selected: false,
    }));
    this.selectedItems = [];
  }

  ngOnInit(): void {
    // initItems() is already called by the agents setter.
    // This hook is kept as a safety fallback for any future direct bindings.
    if (this.allItems.length === 0 && this._agents.length > 0) {
      this.initItems();
    }
  }

  get isAllSelected(): boolean {
    return this.allItems.length > 0 && this.allItems.every((a) => a.selected);
  }

  getTypeIcon(type: string): string {
    return this.typeIconMap[type] ?? 'assets/images/virtusa-icons/local-agent.svg';
  }

  toggleSelect(item: any): void {
    item.selected = !item.selected;
    this.syncSelected();
  }

  toggleSelectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.allItems.forEach((a) => (a.selected = checked));
    this.syncSelected();
  }

  syncSelected(): void {
    this.selectedItems = this.allItems.filter((a) => a.selected);
  }

  removeChip(item: any): void {
    item.selected = false;
    this.syncSelected();
  }

  getStatusClass(status: string): string {
    const map: Record<string, string> = {
      Online:    'status-online',
      Offline:   'status-offline',
      Executing: 'status-executing',
      Crashed:   'status-crashed',
    };
    return map[status] ?? '';
  }

  reclaim(): void {
    this.activeModal.close({ value: this.selectedItems });
  }

  private toTitleCase(s: string): string {
    return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';
  }
}
